export default "__VITE_ASSET__q54Dj1pR__"